import { render, staticRenderFns } from "./SubmitWarnModal.vue?vue&type=template&id=dde7b884&scoped=true"
import script from "./SubmitWarnModal.vue?vue&type=script&lang=js"
export * from "./SubmitWarnModal.vue?vue&type=script&lang=js"
import style0 from "./SubmitWarnModal.vue?vue&type=style&index=0&id=dde7b884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde7b884",
  null
  
)

export default component.exports